import { useState } from 'react';
import { MainLayout } from '../../components/MainLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@werkstatt/ui';
import { Building2, Mail, FileText, PlugZap, CalendarClock, Tags } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';
import CompanySettings from './CompanySettings';
import EmailSettings from './EmailSettings';
import ImapSettings from './ImapSettings';
import { TemplateEditor } from './TemplateEditor';
import OnlineBookingSettings from './OnlineBookingSettings';
import VehicleCategories from './VehicleCategories';

export default function Settings() {
  const [activeTab, setActiveTab] = useState('company');
  const { user } = useAuthStore();
  const readOnly = user?.role !== 'admin';

  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <h1 className="font-display text-3xl font-bold">Einstellungen</h1>
          <p className="text-muted-foreground mt-2">
            Verwalten Sie Ihre Unternehmens- und E-Mail-Einstellungen
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <TabsList className="grid w-full grid-cols-2 lg:w-[880px] lg:grid-cols-6">
            <TabsTrigger value="company" className="flex items-center gap-2">
              <Building2 className="w-4 h-4" />
              Unternehmen
            </TabsTrigger>
            <TabsTrigger value="email" className="flex items-center gap-2">
              <Mail className="w-4 h-4" />
              E-Mail
            </TabsTrigger>
            <TabsTrigger value="imap" className="flex items-center gap-2">
              <PlugZap className="w-4 h-4" />
              Postfachabruf
            </TabsTrigger>
            <TabsTrigger value="templates" className="flex items-center gap-2">
              <FileText className="w-4 h-4" />
              Vorlagen
            </TabsTrigger>
            <TabsTrigger value="categories" className="flex items-center gap-2">
              <Tags className="w-4 h-4" />
              Kategorien
            </TabsTrigger>
            <TabsTrigger value="online-booking" className="flex items-center gap-2">
              <CalendarClock className="w-4 h-4" />
              Online-Buchung
            </TabsTrigger>
          </TabsList>

          <TabsContent value="company" className="space-y-4">
            <CompanySettings />
          </TabsContent>

          <TabsContent value="email" className="space-y-4">
            <EmailSettings />
          </TabsContent>

          <TabsContent value="imap" className="space-y-4">
            <ImapSettings />
          </TabsContent>

          <TabsContent value="templates" className="space-y-4">
            <TemplateEditor readOnly={readOnly} />
          </TabsContent>

          <TabsContent value="categories" className="space-y-4">
            <VehicleCategories />
          </TabsContent>

          <TabsContent value="online-booking" className="space-y-4">
            <OnlineBookingSettings />
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
}
